const utils = require("frontend-controller/lib/utils")
module.exports = {
	extends: [
		'/',
		'base',
		'tableSimple',
		'table'
	],

	config: {
		isSortable: true,
		lazyloadStepSize: 25,
		preventSortOfField: {},
		buttonContext: 'userSessions',
		renderEmptyBeforReady: true,
		inline: true,
	},

	model: {
		resourceFilters: {
			order: [{
				fieldCode: 'userSessionGroupID',
				direction: 'desc'
			},{
				fieldCode: 'serviceID',
				direction: 'asc'
			},{
				fieldCode: 'lastSeenTS',
				direction: 'desc'
			}]
		}
	},

	methods: {
		refreshViewData: function(){
			var self = this;
			self.performAndStoreAction(
				'refreshViewDataInEffect',
				self.prepareAction('refreshViewData'),
				true
			).then(function(){
				return self.refreshData();
			}).then(function(){
				getComponent('statusController').addPanel('status.done.dataRefreshed')
			});
		},

		loadResourcesGranted: function(storage, resourceFilters, actionKey, fieldCode, attachTriggerOptions){
			// lastGroup filter is a strict boolean and has to be present
			const atLeastOneFilterPresent = !utils.isEmpty((resourceFilters || {}).filters || {})
			return actionKey !== 'refreshResources' || atLeastOneFilterPresent;
		},

		showEdit: function(rowID, rowData, buttonMode){
			const {
				serviceID,
				sessionID,
				authDomain
			} = ((rowData || {}).attributes || {})

			if(serviceID && sessionID && authDomain){
				return this.performAndStoreAction(
					'show_userSession_inEffect',
					this.prepareAction('show_userSession', undefined, undefined, {
						source: {
							submit: {
								data: {
									data: {
										attributes: {
											serviceID,
											sessionID,
											authDomain
										}
									}
								}
							}
						}
					}),
					true
				).then(result => {
					this.openJSONEditor((((result || {}).response || {}).data || {}).attributes || {})
				}).fail(error => {
					console.error('userSession could not be loaded', error)
				})
			}
		},

		openJSONEditor: function(dataJSON){
			if(!this.model.controller) return;
			this.model.controller.find('base_treesManagement_interfaceHelpersForm', formComponent => {
				const $jsonEditorButton = formComponent.$.find('.base_form_fields_json-editor-button')
				if($jsonEditorButton.length > 0){
					const jsonEditorButtonComponent = getComponent($jsonEditorButton)
					if(jsonEditorButtonComponent){
						jsonEditorButtonComponent.open(dataJSON)
					}
				}
			})
		}
	},

	hooks: {
		attach: function($element, options){
			var self = this;
			if(!self.model.controller){
				self.closest('templates_globals_userSessions_entity_controller', function(controller){
					self.model.controller = controller
				});
			}

			self.model.$table = $element.find('table');
		}
	},

	handlers: [{
		name: 'recordControllerResourcesModified',
		handle: function(callerComponent) {
			if(this.config.isReady){
				this.refreshData();
			}
		}
	}]
}